import * as R from 'ramda'

const REGIONS_FALLBACK = {}
export const getRegions = R.pathOr(REGIONS_FALLBACK, ['__items'])
